var $ = jQuery;
import {debounce} from '../utils/utilities.js';

function dimensionSpacer() {
  //if legacy article and desktop
  if ($('article._legacy').length && $(window).width() > 1023) {
    $('article._legacy').each(function() {
      //if commentary, apply the height of the author card
      if ($(this).hasClass('commentary')) {
        let authorCardHeight = $(this).find('.author-card').outerHeight();
        $(this).find('.body__spacer').css('height', authorCardHeight + 'px');
      }
      //if report, find the expert card or contributor card and assign height to spacer
      else if($(this).hasClass('report')) {
        var cardHeight;
        if($(this).find('.expert-card').length) {
          cardHeight = $(this).find('.expert-card').outerHeight();
        }
        else if($(this).find('.contributor-card').length) {
          cardHeight = $(this).find('.contributor-card').outerHeight();
        }

        $(this).find('.body__spacer').css('height', cardHeight + 'px');
      }
    });
  }
}


function init() {
  var debouncedDimension = debounce(function() {
    dimensionSpacer();
  }, 20);

  dimensionSpacer();

  $(document).on('newSectionAdded', function(e, context) {
    dimensionSpacer();
  });

  $(window).on('resize', debouncedDimension);
}

export { init };
